'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = TabItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./tab-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Tab Item Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function TabItem(props) {
    var isActive = props.isActive,
        isDisabled = props.isDisabled,
        onClick = props.onClick,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)({
        'sb-tabs__item': true,
        'sb-tabs__item--active': isActive,
        'sb-tabs__item--disabled': isDisabled
    });

    return (0, _jsx3.default)('li', {
        className: classNames,
        onClick: onClick,
        id: id
    }, void 0, props.children);
}
// css
//# sourceMappingURL=TabItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/tabs/TabItem.js
// module id = 614
// module chunks = 0